import { takeLatest, put, select, call, delay } from 'redux-saga/effects';

import { currentLocationSelector } from '../../common/selectors';
import {
  APPOINTMENT_PROGRESS_TYPES,
  appointmentProgressActions,
} from '../progress-types';
import {
  redirectToUsers,
  rootAppointmentFormPath,
} from '../../../utils/appointments/redirect-utils';

function* handleValidateOnMount() {
  const currentLocation = yield select(currentLocationSelector);
  if (currentLocation !== rootAppointmentFormPath) {
    yield call(redirectToUsers);
  }
  yield delay(200);
  yield put(appointmentProgressActions.finishValidate());
}

export default function* validateOnMount() {
  yield takeLatest(APPOINTMENT_PROGRESS_TYPES.VALIDATE, handleValidateOnMount);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/validate-on-mount-saga.js